module.exports = __webpack_public_path__ + "media/alaska/glacier-a6f5334d.jpg";